import React from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/ui-bits";
import { comparison } from "@/data/mockData";

export default function Comparison() {
  return (
    <div className="cv-container py-20 sm:py-28">
      <Reveal className="mb-12 max-w-3xl">
        <div className="mb-4"><SectionLabel color="text-violet">Comparison</SectionLabel></div>
        <h1 className="font-heading text-4xl font-black tracking-tight sm:text-5xl">
          Why use five platforms when your career can have one home?
        </h1>
        <p className="mt-4 text-lg text-muted-foreground">
          CVOLVE brings job aggregation, CV intelligence, ATS, application automation, career intelligence and interview prep into one platform. Feature availability varies.
        </p>
      </Reveal>

      <Reveal>
        <div className="overflow-x-auto rounded-3xl border border-border shadow-card">
          <table className="w-full min-w-[720px] text-sm">
            <thead>
              <tr className="border-b border-border bg-secondary/50">
                <th className="sticky left-0 bg-secondary/50 p-4 text-left font-heading">Capability</th>
                {comparison.categories.map((c) => (
                  <th key={c} className={`p-4 text-center font-heading ${c === "CVOLVE" ? "text-electric" : "text-muted-foreground"}`}>
                    {c}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {comparison.rows.map((r, ri) => (
                <tr key={r} className="border-b border-border last:border-0 hover:bg-secondary/30">
                  <td className="sticky left-0 bg-card p-4 font-medium">{r}</td>
                  {comparison.categories.map((c) => {
                    const v = comparison.matrix[c][ri];
                    return (
                      <td key={c} className={`p-4 text-center ${c === "CVOLVE" ? "bg-electric/5" : ""}`}>
                        {v === 2 ? <Check className="mx-auto h-[18px] w-[18px] text-[#15803d] dark:text-lime" strokeWidth={3} /> :
                          v === 1 ? <span className="text-xs font-medium text-muted-foreground">partial</span> :
                          <span className="text-muted-foreground">—</span>}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="mt-10 flex flex-col items-center gap-3 text-center">
          <Link to="/signup" className="cv-btn-primary text-base">Bring your career home <ArrowRight className="h-4 w-4" /></Link>
          <span className="text-xs text-muted-foreground">Comparison reflects broad platform categories, not specific competitors.</span>
        </div>
      </Reveal>
    </div>
  );
}
